export const startArtifactDownload = (
  downloadUrl: string,
  locationRef: Pick<Location, 'assign'> = window.location
) => {
  const url = new URL(downloadUrl);
  if (url.protocol !== 'https:') throw new Error('invalid_download_url');
  locationRef.assign(url.toString());
};
